const DATE_FORMATTER: Intl.DateTimeFormat = new Intl.DateTimeFormat('nl-NL', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

const TIME_FORMATTER: Intl.DateTimeFormat = new Intl.DateTimeFormat('nl-NL', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export function formatNoteDateTime(isoDatetime: string): string {
  const date: Date = new Date(isoDatetime);
  if (isNaN(date.getTime())) return '';
  return `${DATE_FORMATTER.format(date)} • ${TIME_FORMATTER.format(date)}`;
}
